<template>
    <div>
        <div class="row g-3 mb-4 align-items-center justify-content-between">
            <div class="col-auto">
                <h1 class="app-page-title mb-0">{{ __('instructors.manage-instructors-title') }}</h1>
            </div>
            <div class="col-auto">
                <div class="page-utilities">
                    <div class="row g-2 justify-content-start justify-content-md-end align-items-center">
                        <div class="col-auto">
                            <input type="text" class="form-control" style="width:280px;"
                                v-model="search"
                                @input="onSearch"
                                @keyup.enter="searchNow"
                                :placeholder="__('instructors.search-placeholder')">
                        </div>
                        <div class="col-auto">
                            <a class="btn app-btn-secondary" href="#" @click.prevent="addUser">
                                <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" class="h-6 w-6"
                                    fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                {{ __('actions.create') }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="instructors.length > 0">
            <div class="app-card app-card-orders-table shadow-sm mb-5">
                <div class="app-card-body">
                    <div class="table-responsive">
                        <table class="table app-table-hover mb-0 text-left">
                            <thead>
                                <tr>
                                    <th class="cell">{{ __('instructors.name') }}</th>
                                    <th class="cell">{{ __('instructors.email') }}</th>
                                    <th class="cell">{{ __('instructors.wrm-number') }}</th>
                                    <th class="cell">{{ __('instructors.role') }}</th>
                                    <th class="cell"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(instructor, index) in instructors" :key="index">
                                    <td class="cell">{{ instructor.name }}</td>
                                    <td class="cell">{{ instructor.email }}</td>
                                    <td class="cell">{{ instructor.wrm_number }}</td>
                                    <td class="cell">{{ roleNames(instructor) }}</td>
                                    <td class="cell">
                                        <a class="btn app-btn-secondary" href="#"
                                            @click.prevent="getUser(instructor)">{{ __('actions.edit') }}</a>
                                        <a class="btn app-btn-danger" href="#"
                                            @click.prevent="deleteUser(instructor)">{{ __('actions.delete') }}</a>
                                        <a class="btn app-btn-primary" href="#"
                                            @click.prevent="impersonateUser(instructor)">support</a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <pagination-component :pagination="pagination" @paginate="getInstructors()"></pagination-component>
        </div>
        <div v-else-if="search" class="app-card alert alert-dismissible shadow-sm mb-5 border-left-decoration"
            role="alert">
            <div class="inner">
                <div class="app-card-body p-3 p-lg-4">
                    <h3 class="mb-3">{{ __('instructors.no-results-title') }}</h3>
                    <div>{{ __('instructors.no-results-text') }}</div>
                </div>
            </div>
        </div>
        <div v-else class="app-card alert alert-dismissible shadow-sm mb-5 border-left-decoration" role="alert">
            <div class="inner">
                <div class="app-card-body p-3 p-lg-4">
                    <h3 class="mb-3">{{ __('instructors.no-instructors-title') }}</h3>
                    <div class="row gx-5 gy-3">
                        <div class="col-12 col-lg-9">

                            <div>{{ __('instructors.no-instructors-text') }}</div>
                        </div>
                        <div class="col-12 col-lg-3">
                            <a class="btn app-btn-primary" href="#" @click.prevent="addUser">
                                <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" class="h-6 w-6"
                                    fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>{{ __('instructors.add') }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <instructors-modal ref="InstructorUserModal" :available-roles="roles"
            @updated="getInstructors()"></instructors-modal>
    </div>
</template>

<script>
export default {
    name: "usersComponents",

    data() {
        return {
            instructors: [],
            pagination: {
                current_page: 1
            },
            role: 'instructor',
            roles: [],
            search: '',
            searchTimeout: null
        }
    },

    created() {
        this.getInstructors();
    },

    methods: {
        getInstructors: function () {
            axios.get('/get-instructors', {
                params: {
                    page: this.pagination.current_page,
                    search: this.search
                }
            })
                .then(response => {
                    this.instructors = response.data.instructors.data
                    this.pagination = response.data.instructors
                    this.roles = response.data.roles
                })
        },

        roleNames: function (instructor) {
            if (!instructor.roles || instructor.roles.length === 0) {
                return this.__('instructors.no-role')
            }

            return instructor.roles.map(role => role.name).join(', ')
        },

        // Tijdens het typen zoeken, maar pas nadat het even stil is gebleven
        onSearch: function () {
            clearTimeout(this.searchTimeout)
            this.searchTimeout = setTimeout(this.searchNow, 300)
        },

        searchNow: function () {
            clearTimeout(this.searchTimeout)
            this.pagination.current_page = 1
            this.getInstructors()
        },

        getUser: function (instructor) {
            this.$refs.InstructorUserModal.setUser(instructor)
            $('#InstructorUserModal').modal('show')
        },

        addUser: function () {
            this.$refs.InstructorUserModal.setRole(this.role)
            $('#InstructorUserModal').modal('show')
        },

        deleteUser: function (instructor) {
            Swal.fire({
                title: this.__('actions.confirm'),
                text: this.__('actions.confirm-text'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: this.__('actions.confirm-yes'),
                cancelButtonText: this.__('actions.confirm-no'),
                showLoaderOnConfirm: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                reverseButtons: true,
                preConfirm: login => {
                    return axios.delete(`/instructors/${instructor.id}`).then(response => {
                        return response.data
                    })
                        .catch(error => {
                            Swal.showValidationMessage(`Something went Wrong!: ${error}`)
                        })
                },
                allowOutsideClick: () => !Swal.isLoading()
            }).then(result => {
                if (result.value) {
                    Toast.fire({ icon: 'success', title: result.value.message })
                    this.getInstructors()
                }
            })
        },

        impersonateUser(instructor) {
            Swal.fire({
                title: this.__('actions.confirm'),
                text: `Inloggen als ${instructor.name}?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Ja, inloggen',
                cancelButtonText: this.__('actions.confirm-no'),
            }).then(result => {
                if (result.isConfirmed) {
                    axios.post(`/impersonate/${instructor.id}`)
                        .then(response => {
                            window.location.href = '/home'; // Of andere gewenste redirect
                        })
                        .catch(error => {
                            console.error(error);
                            Swal.fire('Fout', 'Kon niet inloggen als gebruiker.', 'error');
                        });
                }
            });
        }
    }
}
</script>

<style scoped></style>
